// Glify sesji 37, runda R3: platformy na drugiej grafice, pięć glifów faktów sekcji
// zamykającej i glif tokena.
//
// Rysunki jeden do jednego z `design/claude-design-wyniki/37-minimal-wejscie/src/glify37.svg`
// (te same ścieżki, ta sama siatka, ta sama grubość kreski). Sesja narysowała je U SIEBIE,
// a nie we wspólnym `glify.svg`, bo w tamtym arkuszu pracują równolegle sesje 35 i 39;
// ta sama granica obowiązuje tutaj, więc nic nie dopisujemy do `ds/media/Glyph`.
// Lucide też nie ma tych kształtów: znaki platform są z niego świadomie usunięte,
// a „karta przekreślona” i „token” to rysunki tej sesji.
//
// Kreska, nie wypełnienie: `currentColor`, więc glif bierze kolor tekstu, w którym stoi
// (ta sama para plików obsługuje ciemną scenę i jasną stronę). Wyjątkiem są ZNAKI PLATFORM:
// od paczki P1 (21.09) niosą barwy marek i rysuje je `ds/media/PlatformLogo` — jedno źródło
// dla produktu i dla strony.

import { PlatformLogo, type PlatformLogoName } from '../../ds/media/PlatformLogo'
import { TOKEN_COIN, TOKEN_COIN_SMALL } from '../../ds/media/tokenCoin'

export type PlatformName = PlatformLogoName
export type Glyph37Name = 'nocard' | 'lock' | 'key' | 'shield' | 'calx' | 'token'

/**
 * Znak platformy — wypełnia swojego rodzica.
 *
 * Paczka P1 A (2026-09-21): rysunek już NIE stoi tutaj. Właściciel poprosił o „normalne mini
 * loga” w barwach marek, a barwny znak nie może mieć dwóch kopii — jedna z nich wcześniej czy
 * później rozjedzie się z drugą i strona publiczna pokaże inne logo niż produkt. Cały rysunek
 * leży w `ds/media/PlatformLogo`; ten komponent zostaje nazwą, którą woła grafika sesji 37.
 */
export function PlatformGlyph({ name }: { name: PlatformName }) {
  return <PlatformLogo name={name} />
}

/**
 * Glif treści w siatce 24; `size` w px, bo stoi obok tekstu o znanej wielkości.
 *
 * MONETA PONIŻEJ 20 px ma WŁASNY KRÓJ (`TOKEN_COIN_SMALL`, siatka 16), tak samo jak
 * w aplikacji (`ds/media/Glyph` → `token-s`): skalowanie siatki 24 w dół zamyka otwory
 * nut w plamę. Próg pilnuje TEN komponent, a nie pamięć wołającego — górny pasek
 * Pierwszych kroków prosił o 18 px i dostawał duży rysunek (przegląd D).
 */
export function Glyph37({ name, size = 18 }: { name: Glyph37Name; size?: number }) {
  const smallCoin = name === 'token' && size < 20
  return (
    <svg viewBox={smallCoin ? '0 0 16 16' : '0 0 24 24'} width={size} height={size} fill="none" stroke="currentColor"
         strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
         style={{ display: 'block', flexShrink: 0 }}>
      {name === 'nocard' && <>
        <rect x="2.5" y="5.5" width="19" height="13" rx="2.5" />
        <path d="M2.5 10h19" />
        <path d="m4 20 16-16" />
      </>}
      {name === 'lock' && <>
        <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
        <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
      </>}
      {name === 'key' && <>
        <circle cx="8" cy="15" r="4.5" />
        <path d="m11.5 11.5 8-8" />
        <path d="m16 7 3 3" />
      </>}
      {name === 'shield' && <>
        <path d="M12 3 4.5 6v5.5c0 4.6 3.1 8 7.5 9.5 4.4-1.5 7.5-4.9 7.5-9.5V6Z" />
        <path d="m9 12 2.2 2.2L15.2 10" />
      </>}
      {name === 'calx' && <>
        <rect x="3.5" y="5" width="17" height="15.5" rx="2.5" />
        <path d="M3.5 10h17M8 3v4M16 3v4" />
        <path d="m10 13.5 4 4m0-4-4 4" />
      </>}
      {/* Moneta ED: pełny krążek z nutami wyciętymi jako otwory. TEN SAM rysunek co
          w aplikacji — obie strony czytają `ds/media/tokenCoin`, więc waluta nie może
          wyglądać inaczej na stronie publicznej niż w produkcie. Siatka rysunku to 24,
          czyli dokładnie siatka tego zestawu. */}
      {name === 'token' && <path d={smallCoin ? TOKEN_COIN_SMALL : TOKEN_COIN} fill="currentColor" fillRule="nonzero" stroke="none" />}
    </svg>
  )
}
